import { forwardRef } from 'react';

import { withCellWrapper } from './../helpers';
import { TextEllipsisWithTooltip } from 'components/Kizen/Table';
import ValidatedField from 'components/Kizen/ValidatedField';
import TextInputInline from 'components/Inputs/inline/TextInput';
import { scrollFieldIntoView } from 'components/Fields/helpers';

const _NameCell = forwardRef(
  (
    {
      field,
      entityId,
      onSubmit,
      value,
      objectId: modelId,
      column,
      editable,
      autoFocus,
      pathPrefix = '',
      target = '',
      shouldFocusNext,
      enableLink = true,
    },
    ref
  ) => {
    if (!column.meta.editable || !editable) {
      return (
        <TextEllipsisWithTooltip
          ref={ref}
          type={enableLink ? 'link' : 'text'}
          to={enableLink ? `${pathPrefix}${modelId}/${entityId}/details` : null}
          target={target}
          data-qa-id={value}
        >
          {value}
        </TextEllipsisWithTooltip>
      );
    }
    return entityId !== 'new' ? (
      <ValidatedField
        type={enableLink ? 'link' : 'text'}
        shouldFocusNext={shouldFocusNext}
        to={enableLink ? `${pathPrefix}${modelId}/${entityId}/details` : null}
        target={target}
        value={value}
        field={field}
        entityId={entityId}
        position="unset"
        fieldId={column.id}
        onSubmit={async (data) => {
          return onSubmit(data);
        }}
      />
    ) : (
      <TextInputInline
        isNew
        ref={ref}
        shouldFocusNext={shouldFocusNext}
        value={value}
        field={field}
        entityId={entityId}
        onSubmit={async (data) => {
          return onSubmit(data);
        }}
        onAutoFocus={scrollFieldIntoView}
        autoFocus={autoFocus}
        submitUnchanged={true}
      />
    );
  }
);

export const NameCell = withCellWrapper(_NameCell);
